module.exports = __webpack_public_path__ + "img/20201101_132306.33e8d7bc.jpg";